'use strict';

var EditNat = require('actionGroups/oneoneNat/Nat');

module.exports = {
  Model: EditNat,
};
